import { useQuery } from "@tanstack/react-query";
import { apiInstance } from "../utils/_apiInstance";

export interface Note {
  id: string;
  text: string;
  texto?: string;
}

export interface GetSpecificNotesResponse {
  documento: string;
  notas: Note[];
}

export const getSpecificNotes = async (
  legislationId: string,
  notes: string[],
) => {
  const response = await apiInstance.get<GetSpecificNotesResponse>(
    `pesquisa/legislacao/${legislationId}/nota`,
    {
      params: {
        nota: notes.join(","),
      },
    },
  );
  return response.data;
};

export const useGetSpecificNotesQuery = (
  legislationId: string,
  notes: string[],
  enabled = true,
) =>
  useQuery({
    queryKey: ["get-specific-notes", legislationId, notes.join(",")],
    queryFn: async () => getSpecificNotes(legislationId, notes),
    enabled,
  });
